import React, { Component } from 'react';
import { msalConfig, tokenRequest, loginRequest, graphConfig } from './config';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import {myMSALObj,requestOptions,proxyUrl,tokenUrl,emptySearchRequestOptions,detailsBaseUrl,restrictedEntities,environmentSetUp,environmentSelection} from './components/Configurations';
import $ from "jquery";
// import * from 'moment'

const colorMap = {
  "PUBLIC":"green",
  "CONFIDENTIAL":"orange",
  "STRICTLY CONFIDENTIAL":"red",
  "UNCLASSIFIED":"grey"
}
const colorMap2 = {
  "YES":"#F2635C",
  "NO":"#1BA397"
}
const colorMap3 = {
  "SAP":"#006699",
  "EXCEL":"#006600",
  "HTML":"#cc6600"
}

let UNHQ_entities = []
let RC_entities = []
let FM_entities = []
let OAFH_entities = []
let OTHER_entities = []



class Search extends Component{

  constructor(props){

    super(props);
    this.state = {
      isCurator:false,
      keyword:'',
      typed:'',
      totalAssets:"Loading...",
      accessToken:"",
      expiresOn:"",
      searchResults:null,
      detailedResults:[],
      guid:"",
      suggestedAsset:[],
      screenwidth:window.innerWidth,
      searchFilters:[{"assetType": "Data Catalog"}]
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleLogOut = this.handleLogOut.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleSelectEntity = this.handleSelectEntity.bind(this);
    this.handleSelectSensitivityLevel = this.handleSelectSensitivityLevel.bind(this);
    this.handleClickSuggestion = this.handleClickSuggestion.bind(this)

  }

  handleChange(event) {
  console.log(event.target.value.length);
  console.log(event.target.value);
    this.setState({
      typed: event.target.value,
      keyword:event.target.value
    },()=>{
      if(this.state.typed !==""){
        let currentTime = new Date().getTime()/1000
        if (sessionStorage.getItem('accessToken') === null || sessionStorage.getItem('expiresOn')-18000<=currentTime+60 || sessionStorage.getItem('accessToken') === "undefined"){
          // console.log('token is bad');
          // fetch(proxyUrl + tokenUrl,requestOptions)
          // fetch("https://data-catalog-token-server.azurewebsites.net/api/getToken")
          var currentDateTime = new Date();
          console.log('the new code');
          fetch(environmentSetUp['purviewAccessToken'][environmentSelection])
          .then(res=>res.json()).then(data=>this.setState({
            accessToken:data.access_token,
            expiresOn:new Date(currentDateTime.setSeconds(currentDateTime.getSeconds() + data.expires_in)).getTime()/1000
          },()=>{
            sessionStorage.setItem('accessToken',this.state.accessToken);
            sessionStorage.setItem('expiresOn',this.state.expiresOn);
            // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/search/suggest",{
            fetch(environmentSetUp["searchSuggestUrl"][environmentSelection],{
              method:"POST",
              headers:{
                  'Authorization':'Bearer ' + sessionStorage.getItem('accessToken'),
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                keywords:this.state.typed,
                filter:{
                  or:[
                    {"assetType": "Data Catalog"}
                  ]
                },
                limit:10
              })
            }).then(res=>res.json()).then(data=>this.setState({suggestedAsset:data}))
          }))
        }else{
          // console.log('token is good');
          // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/search/suggest",{
          fetch(environmentSetUp["searchSuggestUrl"][environmentSelection],{
            method:"POST",
            headers:{
                'Authorization':'Bearer ' + sessionStorage.getItem('accessToken'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              keywords:this.state.typed,
              filter:{
                or:[
                  {"assetType": "Data Catalog"}
                ]
              },
              limit:10
            })
          }).then(res=>res.json()).then(data=>this.setState({suggestedAsset:data}))
        }
      }
    })
  };

  handleSubmit(event) {
    debugger;
    // console.log(this.state)
    event.preventDefault();
    this.props.history.push({
      pathname:'/results',
      search:"keyword="+this.state.keyword,
      state:{
        keyword:this.state.keyword,
        accessToken:this.state.accessToken,
        expiresOn:this.state.expiresOn
      }
  })
  };

  handleCreate(){
      this.props.history.push({
          pathname:'/create'
      })
  }

  handleLogOut(){
    sessionStorage.setItem('user','');
    sessionStorage.setItem('email','');
    sessionStorage.setItem('keyword','');
    sessionStorage.setItem('accessToken','');
    sessionStorage.setItem('expiresOn','');
    sessionStorage.setItem('role','');
    this.props.history.push('/logout');
    myMSALObj.logout();
    
  };

  handleClick(event){
    // console.log(event.target.id)
    this.setState({guid:event.target.id},()=>{
      this.props.history.push({
          pathname:'/details',
          search:"guid="+this.state.guid,
          state:{guid:this.state.guid}
      })
  });
  }

  handleClickSuggestion(event){
    // console.log("clicked something")
    this.setState({guid:event.target.id},()=>{
      this.props.history.push({
          pathname:'/details',
          search:"guid="+this.state.guid,
          state:{guid:this.state.guid}
      })
  });
  } 


  handleSelectEntity(event){
    debugger;
    // console.log(event.target.text)
    event.preventDefault();
    this.props.history.push({
      pathname:'/results',
      search:"keyword="+this.state.keyword+"&entity="+event.target.text
  })
  }

  handleSelectSensitivityLevel(event){
    // console.log(event.target.text)
    this.props.history.push({
      pathname:'/results',
      search:"keyword="+this.state.keyword+"&sensitivityLevel="+event.target.text
  })
  }



  async componentDidMount(){    

    function removeItemOnce(arr, value) {
      var index = arr.indexOf(value);
      if (index > -1) {
        arr.splice(index, 1);
      }
      return arr;
    }; 

    var restrictedEntitiesDuplicate = restrictedEntities;

    

    if (myMSALObj.getAccount() === null){
      myMSALObj.loginRedirect(loginRequest);
    }else{
      // myMSALObj.acquireTokenSilent(loginRequest)
      // console.log(myMSALObj.getAccount())      //ONLY USED TO FETCHING GUID FOR TOKEN SERVER TESTING. COMMENT THIS LINE OUT BEFORE PUSHING ONTO PROD SERVER.
      sessionStorage.setItem('user',myMSALObj.getAccount().name);
      sessionStorage.setItem('email',myMSALObj.getAccount().userName);
      fetch("https://data-catalog-token-server-dev-v2.azurewebsites.net/api/entityLookUpNew?email="+myMSALObj.getAccount().userName).then(res=>res.json()).then(data=>sessionStorage.setItem('userEntity',data.entity)).then(
        removeItemOnce(restrictedEntitiesDuplicate,sessionStorage.getItem('userEntity'))
      ).then(restrictedEntitiesDuplicate.map(item=>(
        this.state.searchFilters.push({
          "not":{
            "attributeName": "Entity_ID",
            "operator": "eq",
            "attributeValue": item  
        }
        })
      )))
    }

    let currentTime = new Date().getTime()/1000
    
    if (sessionStorage.getItem('accessToken') === null || sessionStorage.getItem('expiresOn')-18000<=currentTime+60 || sessionStorage.getItem('accessToken') === "undefined"){
      // console.log('token is bad');

      // const res = await fetch(proxyUrl + tokenUrl,requestOptions);
      // const res = await fetch("https://data-catalog-token-server.azurewebsites.net/api/getToken")
      const res = await fetch(environmentSetUp['purviewAccessToken'][environmentSelection])
      const data = await res.json();
      var currentDateTime = new Date();
      currentDateTime.setSeconds(currentDateTime.getSeconds() + data.expires_in);
      // console.log(data)
      this.setState({
        accessToken:data.access_token,
        expiresOn:new Date(currentDateTime).getTime()/1000
        // accessToken:data.accessToken,
        // expiresOn:new Date(data["expiresOn"]).getTime()/1000
      },()=>{

        // fetch("https://management.azure.com/subscriptions/92c092cf-544c-48c7-9ff4-37f0f0247e75/resourceGroups/OICT-PSGD-DATA-ADC/providers/Microsoft.Purview/accounts/sys-purview/providers/Microsoft.Authorization/roleAssignments?api-version=2015-07-01&$filter=assignedto('3608b1bb-0029-48a4-b3c7-5962aaeff6c6')",{
        //   method: 'GET',
        //   headers:{
        //       'Authorization':'Bearer ' + this.state.accessToken,
        //       'Content-Type': 'application/json'
        //   }
        // }).then(res=>res.json()).then(data=>console.log(data))

          // console.log(this.state)
          sessionStorage.setItem('accessToken',this.state.accessToken);
          sessionStorage.setItem('expiresOn',this.state.expiresOn);
          // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/search/advanced",{
          fetch(environmentSetUp["advancedSearchUrl"][environmentSelection],{
          method: 'POST',
          headers:{
              'Authorization':'Bearer ' + this.state.accessToken,
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              keywords:'',
              filter:{
                or:this.state.searchFilters
              },
              limit:10
          })
        }).then(res=>res.json())
          .then(data=>this.setState({
            totalAssets:data['@search.count'],
            searchResults:data
          },()=>{
            this.state.searchResults.value?.map(item=>(
              // fetch(detailsBaseUrl+item.id,{
              fetch(environmentSetUp["detailBaseUrl"][environmentSelection]+item.id,{
                method: 'GET',
                headers:{
                    'Authorization':'Bearer ' + this.state.accessToken,
                    'Content-Type': 'application/json'
                }}).then(res=>res.json()).then(data=>this.setState(prevState=>{
                  prevState.detailedResults.push(data.entity);
                  console.log(JSON.stringify(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']));
                  data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']==="United Nations"&&!UNHQ_entities.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])?UNHQ_entities.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']):UNHQ_entities=UNHQ_entities
                  data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']==="Regional Commission"&&!RC_entities.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])?RC_entities.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']):RC_entities=RC_entities
                  data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']==="Field Mission"&&!FM_entities.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])?FM_entities.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']):FM_entities=FM_entities
                  data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']==="Office Away from Headquarters"&&!OAFH_entities.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])?OAFH_entities.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']):OAFH_entities=OAFH_entities
                  data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']==="Other"&&!OTHER_entities.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])?OTHER_entities.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']):OTHER_entities=OTHER_entities
                },()=>{
                  this.setState({
                    newDetailedResults:this.state.detailedResults,
                  })
                }))
            ))
          }))
      })
    }else{
      // console.log('token is good');
      // console.log(this.state.screenwidth)
      // console.log(currentTime)
      // fetch("https://data-catalog-token-server.azurewebsites.net/api/getToken").then(res=>res.json()).then(data=>console.log(new Date(data["expiresOn"]).getTime()/1000-currentTime))
      // fetch("http://localhost:5000/api/getToken").then(res=>res.json()).then(data=>console.log(new Date(data["expiresOn"]).getTime()/1000-currentTime))
      // fetch(proxyUrl + tokenUrl,requestOptions).then(res=>res.json()).then(data=>console.log(data["expires_on"]-currentTime))
      // fetch("https://sys-purview.catalog.purview.azure.com/api/atlas/v2/search/advanced",{
      fetch(environmentSetUp["advancedSearchUrl"][environmentSelection],{
          method: 'POST',
          headers:{
              'Authorization':'Bearer ' + sessionStorage.getItem('accessToken'),
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              keywords:'',
              filter:{
                or:this.state.searchFilters
              },
              limit:10
          })
        }).then(res=>res.json())
          .then(data=>this.setState({
            accessToken:sessionStorage.getItem('accessToken'),
            expiresOn:sessionStorage.getItem('expiresOn'),
            totalAssets:data['@search.count'],
            searchResults:data
          },()=>{
            this.state.searchResults.value.map(item=>{
              fetch(environmentSetUp["detailBaseUrl"][environmentSelection]+item.id,{
                method: 'GET',
                headers:{
                    'Authorization':'Bearer ' + this.state.accessToken,
                    'Content-Type': 'application/json'
                }}).then(res=>res.json()).then(data=>this.setState(prevState=>{
                  prevState.detailedResults.push(data.entity);
                  console.log(JSON.stringify(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']));
                  // data.entity.attributes.Organization==="United Nations"&&!UNHQ_entities.includes(data.entity.attributes.Entity_ID)?UNHQ_entities.push(data.entity.attributes.Entity_ID):UNHQ_entities=UNHQ_entities
                  // data.entity.attributes.Organization==="Regional Commission"&&!RC_entities.includes(data.entity.attributes.Entity_ID)?RC_entities.push(data.entity.attributes.Entity_ID):RC_entities=RC_entities
                  // data.entity.attributes.Organization==="Field Mission"&&!FM_entities.includes(data.entity.attributes.Entity_ID)?FM_entities.push(data.entity.attributes.Entity_ID):FM_entities=FM_entities
                  // data.entity.attributes.Organization==="Office Away from Headquarters"&&!OAFH_entities.includes(data.entity.attributes.Entity_ID)?OAFH_entities.push(data.entity.attributes.Entity_ID):OAFH_entities=OAFH_entities
                  // data.entity.attributes.Organization==="Other"&&!OTHER_entities.includes(data.entity.attributes.Entity_ID)?OTHER_entities.push(data.entity.attributes.Entity_ID):OTHER_entities=OTHER_entities
                  data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']==="United Nations"&&!UNHQ_entities.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])?UNHQ_entities.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']):UNHQ_entities=UNHQ_entities
                  data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']==="Regional Commission"&&!RC_entities.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])?RC_entities.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']):RC_entities=RC_entities
                  data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']==="Field Mission"&&!FM_entities.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])?FM_entities.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']):FM_entities=FM_entities
                  data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']==="Office Away from Headquarters"&&!OAFH_entities.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])?OAFH_entities.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']):OAFH_entities=OAFH_entities
                  data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']==="Other"&&!OTHER_entities.includes(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'])?OTHER_entities.push(data.entity['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']):OTHER_entities=OTHER_entities
              
                },()=>{
                  this.setState({
                    newDetailedResults:this.state.detailedResults,
                  })
                }))
            })
          }))
    }

    $("#searchBarInput").focus(function(){
      $("#suggestionDropDown").show();
    })

    $("#searchBarInput").blur(function(){
      let timer;
      timer = setTimeout(function(){
        $("#suggestionDropDown").hide();
      },120);
    })

  }

  

  render(){

    if(myMSALObj.getAccount() === null){
      return (
        <div className="spinner text-center ">
          <div className="spinner-border align-middle" role="status">
              <span className="sr-only">Loading...</span>
          </div>
      </div>
    )
    }else{
      // console.log(this.state)
      // console.log(UNHQ_entities)
        return(
          <React.Fragment>
            <NavBar handleLogOut={this.handleLogOut} handleCreate={this.handleCreate}/>
            
            <div className="container search-main">
            
              <div className="search-wrapper">
              <br/><h5 className="text-secondary main-title">Welcome!</h5><br/><h6 className="font-weight-normal mb-5">The UN Secretariat Data Exchange aims to transform the organization and treat data as a strategic asset. Use the search box below to search for terms or data sets that you are interested in.</h6>
                <br/>
                
                <form onSubmit={this.handleSubmit} className="input-group search-bar">
                  <input id="searchBarInput" type="text" className="form-control" value={this.state.keyword} onChange={this.handleChange} autoComplete="off" placeholder="For example, development, travel, etc." />
                  {this.state.suggestedAsset.value !=='' && this.state.suggestedAsset.value !== undefined && this.state.suggestedAsset.value.length>=1?<div id="suggestionDropDown" className="suggestions bg-light p-3">
                    {this.state.suggestedAsset.value.map((item, index)=>{
                      let newItem =''; 
                      if(item["@search.text"] !== undefined){
                        newItem = item["@search.text"].length<=this.state.screenwidth/13?item["@search.text"].slice(0,this.state.screenwidth/13):item["@search.text"].slice(0,this.state.screenwidth/13)+"..."
                        return(
                          <div key={index} className="align-middle w-100 suggestion-items my-0">
                            <p key={index}  className="suggestion-content py-3 text-break" onMouseDown={this.handleClickSuggestion} id={item.id} dangerouslySetInnerHTML={{ __html: newItem.replace("<em>","<strong>").replace("</em>","</strong>") }} />
                          </div>
                        )
                      }
                      })}
                  </div>:<div></div>}
                  <div  className="input-group-append">       
                      <button  className="btn btn-outline-info" type="submit">
                        <i className="fas fa-search" aria-hidden="true"/>
                      </button> 
                  </div>                
                </form>
                <div className="row">
                  <h6 className="m-0 text-secondary pb-3 mt-3 pl-3 pr-1 main-subtitle w-75 float-left">From {this.state.totalAssets?.toLocaleString()} United Nations internal data assets</h6>
                  <h6 className="m-0 text-secondary pb-3 mt-3 pl-1 pr-3 main-subtitle w-25 float-right text-right" ><a href="/MasterDataSearch">Master Data Portal</a></h6>
                </div>
                
                {/* <div className="mt-3">
                  <p className="text-secondary p-1" >
                    Browse by <a href="#select-by-entity" >Organization/Entity</a> 
                  </p>
                </div> */}
              </div>

              <div className="w-100 featured-data">
                <h3 className="text-center text-secondary text-uppercase mb-5 main-featured-data">
                  featured data
                </h3>


                <div id="carouselFade" className="carousel slide shadow-sm" data-ride="carousel">
                  <ol className="carousel-indicators">
                    <li data-target="#carouselFade" data-slide-to="0" className="active"></li>
                    <li data-target="#carouselFade" data-slide-to="1"></li>
                    <li data-target="#carouselFade" data-slide-to="2"></li>
                    <li data-target="#carouselFade" data-slide-to="3"></li>
                  </ol>
                  <div className="carousel-inner">
                    
                    <div className="carousel-item active" data-interval="10000">
                      <div className="cards-wrapper row">
                        {this.state.detailedResults.sort(function(){return .4 - Math.random()}).slice(0,4).map(record=>{
                          var assetImageIndicator
                          try{
                            require('../public/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png')
                            assetImageIndicator = true
                          }
                          catch(e){
                            assetImageIndicator = false
                          }
                          return(
                            <div key={record.guid} className="mx-1 col card p-3 featured-data-record rounded border-0 shadow-sm" id={record.guid} onClick={this.handleClick}>
                              {assetImageIndicator===true?<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png'} alt="screenshot"></img>:<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']+'.png'} alt="screenshot"></img>}
                              <h6 className="w-100 font-weight-bold text-secondary card-title mb-0 p-1 search-results" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']}
                              </h6>
                              <h6 className="font-weight-bold text-secondary mt-1 small p-1 search-results entity-org" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] + " - " +record['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']}
                              </h6>
                              <h6 className="small text-secondary card-description mt-1 p-1" id={record.guid} onClick={this.handleClick} >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']===""?"There's no description available":record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']}
                              </h6>
                              <div className="w-100 text-center text-secondary px-1 form-inline card-features search-results">
                                  <i className="fas fa-circle fa-xs pt-3" style={{color: colorMap[record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0" >{record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"?"far fa-eye fa-xs pt-3":"far fa-eye-slash fa-xs pt-3"} style={{color:colorMap2[record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">PII: {record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="HTML"?"far fa-file-code pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="EXCEL"?"fas fa-table pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="SAP"?"fas fa-database pt-3":"fas fa-question pt-3"} style={{color:colorMap3[record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']]}}/>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">{record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']}</p>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    
                    <div className="carousel-item" data-interval="10000">
                      <div className="cards-wrapper row">
                        {this.state.detailedResults.sort(function(){return .4 - Math.random()}).slice(0,4).map(record=>{
                          var assetImageIndicator
                          try{
                            require('../public/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png')
                            assetImageIndicator = true
                          }
                          catch(e){
                            assetImageIndicator = false
                          }
                          return(
                            <div key={record.guid} className="mx-1 col card p-3 featured-data-record rounded border-0 shadow-sm" id={record.guid} onClick={this.handleClick}>
                              {assetImageIndicator===true?<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png'} alt="screenshot"></img>:<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']+'.png'} alt="screenshot"></img>}
                              <h6 className="w-100 font-weight-bold text-secondary card-title mb-0 p-1 search-results" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']}
                              </h6>
                              <h6 className="font-weight-bold text-secondary mt-1 small p-1 search-results entity-org" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] + " - " +record['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']}
                              </h6>
                              <h6 className="small text-secondary card-description mt-1 p-1" id={record.guid} onClick={this.handleClick} >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']===""?"There's no description available":record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']}
                              </h6>
                              <div className="w-100 text-center text-secondary px-1 form-inline card-features search-results">
                                  <i className="fas fa-circle fa-xs pt-3" style={{color: colorMap[record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0" >{record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"?"far fa-eye fa-xs pt-3":"far fa-eye-slash fa-xs pt-3"} style={{color:colorMap2[record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">PII: {record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="HTML"?"far fa-file-code pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="EXCEL"?"fas fa-table pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="SAP"?"fas fa-database pt-3":"fas fa-question pt-3"} style={{color:colorMap3[record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']]}}/>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">{record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']}</p>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    
                    <div className="carousel-item" data-interval="10000">
                      <div className="cards-wrapper row">
                        {this.state.detailedResults.sort(function(){return .4 - Math.random()}).slice(0,4).map(record=>{
                          var assetImageIndicator
                          try{
                            require('../public/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png')
                            assetImageIndicator = true
                          }
                          catch(e){
                            assetImageIndicator = false
                          }
                          return(
                            <div key={record.guid} className="mx-1 col card p-3 featured-data-record rounded border-0 shadow-sm" id={record.guid} onClick={this.handleClick}>
                              {assetImageIndicator===true?<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png'} alt="screenshot"></img>:<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']+'.png'} alt="screenshot"></img>}
                              <h6 className="w-100 font-weight-bold text-secondary card-title mb-0 p-1 search-results" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']}
                              </h6>
                              <h6 className="font-weight-bold text-secondary mt-1 small p-1 search-results entity-org" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] + " - " +record['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']}
                              </h6>
                              <h6 className="small text-secondary card-description mt-1 p-1" id={record.guid} onClick={this.handleClick} >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']===""?"There's no description available":record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']}
                              </h6>
                              <div className="w-100 text-center text-secondary px-1 form-inline card-features search-results">
                                  <i className="fas fa-circle fa-xs pt-3" style={{color: colorMap[record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0" >{record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"?"far fa-eye fa-xs pt-3":"far fa-eye-slash fa-xs pt-3"} style={{color:colorMap2[record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">PII: {record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="HTML"?"far fa-file-code pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="EXCEL"?"fas fa-table pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="SAP"?"fas fa-database pt-3":"fas fa-question pt-3"} style={{color:colorMap3[record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']]}}/>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">{record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']}</p>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    
                    <div className="carousel-item" data-interval="10000">
                      <div className="cards-wrapper row">
                        {this.state.detailedResults.sort(function(){return .4 - Math.random()}).slice(0,4).map(record=>{
                          var assetImageIndicator
                          try{
                            require('../public/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png')
                            assetImageIndicator = true
                          }
                          catch(e){
                            assetImageIndicator = false
                          }
                          return(
                            <div key={record.guid} className="mx-1 col card p-3 featured-data-record rounded border-0 shadow-sm" id={record.guid} onClick={this.handleClick}>
                              {assetImageIndicator===true?<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png'} alt="screenshot"></img>:<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']+'.png'} alt="screenshot"></img>}
                              <h6 className="w-100 font-weight-bold text-secondary card-title mb-0 p-1 search-results" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']}
                              </h6>
                              <h6 className="font-weight-bold text-secondary mt-1 small p-1 search-results entity-org" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] + " - " +record['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']}
                              </h6>
                              <h6 className="small text-secondary card-description mt-1 p-1" id={record.guid} onClick={this.handleClick} >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']===""?"There's no description available":record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']}
                              </h6>
                              <div className="w-100 text-center text-secondary px-1 form-inline card-features search-results">
                                  <i className="fas fa-circle fa-xs pt-3" style={{color: colorMap[record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0" >{record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"?"far fa-eye fa-xs pt-3":"far fa-eye-slash fa-xs pt-3"} style={{color:colorMap2[record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">PII: {record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="HTML"?"far fa-file-code pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="EXCEL"?"fas fa-table pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="SAP"?"fas fa-database pt-3":"fas fa-question pt-3"} style={{color:colorMap3[record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']]}}/>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">{record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']}</p>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  
                  </div>
                  <a className="carousel-control-prev" href="#carouselFade" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                  </a>
                  <a className="carousel-control-next" href="#carouselFade" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                  </a>
                </div>



                <div id="carouselFade1" className="carousel slide shadow-sm m-5" data-ride="carousel">
                  <ol className="carousel-indicators">
                    <li data-target="#carouselFade" data-slide-to="4" className="active"></li>
                    <li data-target="#carouselFade" data-slide-to="5"></li>
                    <li data-target="#carouselFade" data-slide-to="6"></li>
                    <li data-target="#carouselFade" data-slide-to="7"></li>
                  </ol>
                  <div className="carousel-inner">
                    <div className="carousel-item active" data-interval="10000">
                      <div className="cards-wrapper row">
                        {this.state.detailedResults.slice(0,2).map(record=>{
                          var assetImageIndicator
                          try{
                            require('../public/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png')
                            assetImageIndicator = true
                          }
                          catch(e){
                            assetImageIndicator = false
                          }
                          return(
                            <div key={record.guid} className="mx-1 col card p-3 featured-data-record rounded border-0 shadow-sm" id={record.guid} onClick={this.handleClick}>
                              {assetImageIndicator===true?<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png'} alt="screenshot"></img>:<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']+'.png'} alt="screenshot"></img>}
                              <h6 className="w-100 font-weight-bold text-secondary card-title mb-0 p-1 search-results" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']}
                              </h6>
                              <h6 className="font-weight-bold text-secondary mt-1 small p-1 search-results entity-org" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] + " - " +record['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']}
                              </h6>
                              <h6 className="small text-secondary card-description mt-1 p-1" id={record.guid} onClick={this.handleClick} >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']===""?"There's no description available":record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']}
                              </h6>
                              <div className="w-100 text-center text-secondary px-1 form-inline card-features search-results">
                                  <i className="fas fa-circle fa-xs pt-3" style={{color: colorMap[record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0" >{record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"?"far fa-eye fa-xs pt-3":"far fa-eye-slash fa-xs pt-3"} style={{color:colorMap2[record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">PII: {record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="HTML"?"far fa-file-code pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="EXCEL"?"fas fa-table pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="SAP"?"fas fa-database pt-3":"fas fa-question pt-3"} style={{color:colorMap3[record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']]}}/>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">{record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']}</p>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    <div className="carousel-item" data-interval="10000">
                      <div className="cards-wrapper row">
                        {this.state.detailedResults.slice(2,4).map(record=>{
                          var assetImageIndicator
                          try{
                            require('../public/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png')
                            assetImageIndicator = true
                          }
                          catch(e){
                            assetImageIndicator = false
                          }
                          return(
                            <div key={record.guid} className="mx-1 col card p-3 featured-data-record rounded border-0 shadow-sm" id={record.guid} onClick={this.handleClick}>
                              {assetImageIndicator===true?<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png'} alt="screenshot"></img>:<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']+'.png'} alt="screenshot"></img>}
                              <h6 className="w-100 font-weight-bold text-secondary card-title mb-0 p-1 search-results" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']}
                              </h6>
                              <h6 className="font-weight-bold text-secondary mt-1 small p-1 search-results entity-org" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] + " - " +record['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']}
                              </h6>
                              <h6 className="small text-secondary card-description mt-1 p-1" id={record.guid} onClick={this.handleClick} >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']===""?"There's no description available":record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']}
                              </h6>
                              <div className="w-100 text-center text-secondary px-1 form-inline card-features search-results">
                                  <i className="fas fa-circle fa-xs pt-3" style={{color: colorMap[record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0" >{record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"?"far fa-eye fa-xs pt-3":"far fa-eye-slash fa-xs pt-3"} style={{color:colorMap2[record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">PII: {record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="HTML"?"far fa-file-code pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="EXCEL"?"fas fa-table pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="SAP"?"fas fa-database pt-3":"fas fa-question pt-3"} style={{color:colorMap3[record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']]}}/>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">{record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']}</p>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    <div className="carousel-item" data-interval="10000">
                      <div className="cards-wrapper row">
                        {this.state.detailedResults.slice(4,6).map(record=>{
                          var assetImageIndicator
                          try{
                            require('../public/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png')
                            assetImageIndicator = true
                          }
                          catch(e){
                            assetImageIndicator = false
                          }
                          return(
                            <div key={record.guid} className="mx-1 col card p-3 featured-data-record rounded border-0 shadow-sm" id={record.guid} onClick={this.handleClick}>
                              {assetImageIndicator===true?<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png'} alt="screenshot"></img>:<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']+'.png'} alt="screenshot"></img>}
                              <h6 className="w-100 font-weight-bold text-secondary card-title mb-0 p-1 search-results" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']}
                              </h6>
                              <h6 className="font-weight-bold text-secondary mt-1 small p-1 search-results entity-org" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] + " - " +record['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']}
                              </h6>
                              <h6 className="small text-secondary card-description mt-1 p-1" id={record.guid} onClick={this.handleClick} >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']===""?"There's no description available":record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']}
                              </h6>
                              <div className="w-100 text-center text-secondary px-1 form-inline card-features search-results">
                                  <i className="fas fa-circle fa-xs pt-3" style={{color: colorMap[record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0" >{record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"?"far fa-eye fa-xs pt-3":"far fa-eye-slash fa-xs pt-3"} style={{color:colorMap2[record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">PII: {record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="HTML"?"far fa-file-code pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="EXCEL"?"fas fa-table pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="SAP"?"fas fa-database pt-3":"fas fa-question pt-3"} style={{color:colorMap3[record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']]}}/>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">{record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']}</p>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    <div className="carousel-item" data-interval="10000">
                      <div className="cards-wrapper row">
                        {this.state.detailedResults.slice(6,8).map(record=>{
                          var assetImageIndicator
                          try{
                            require('../public/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png')
                            assetImageIndicator = true
                          }
                          catch(e){
                            assetImageIndicator = false
                          }
                          return(
                            <div key={record.guid} className="mx-1 col card p-3 featured-data-record rounded border-0 shadow-sm" id={record.guid} onClick={this.handleClick}>
                              {assetImageIndicator===true?<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png'} alt="screenshot"></img>:<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']+'.png'} alt="screenshot"></img>}
                              <h6 className="w-100 font-weight-bold text-secondary card-title mb-0 p-1 search-results" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']}
                              </h6>
                              <h6 className="font-weight-bold text-secondary mt-1 small p-1 search-results entity-org" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] + " - " +record['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']}
                              </h6>
                              <h6 className="small text-secondary card-description mt-1 p-1" id={record.guid} onClick={this.handleClick} >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']===""?"There's no description available":record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']}
                              </h6>
                              <div className="w-100 text-center text-secondary px-1 form-inline card-features search-results">
                                  <i className="fas fa-circle fa-xs pt-3" style={{color: colorMap[record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0" >{record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"?"far fa-eye fa-xs pt-3":"far fa-eye-slash fa-xs pt-3"} style={{color:colorMap2[record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">PII: {record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="HTML"?"far fa-file-code pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="EXCEL"?"fas fa-table pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="SAP"?"fas fa-database pt-3":"fas fa-question pt-3"} style={{color:colorMap3[record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']]}}/>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">{record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']}</p>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                  <a className="carousel-control-prev" href="#carouselFade1" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                  </a>
                  <a className="carousel-control-next" href="#carouselFade1" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                  </a>
                </div>




                <div id="carouselFade2" className="carousel slide shadow-sm m-5" data-ride="carousel">
                  <ol className="carousel-indicators">
                    <li data-target="#carouselFade" data-slide-to="8" className="active"></li>
                    <li data-target="#carouselFade" data-slide-to="9"></li>
                    <li data-target="#carouselFade" data-slide-to="10"></li>
                    <li data-target="#carouselFade" data-slide-to="11"></li>
                  </ol>
                  <div className="carousel-inner">
                    <div className="carousel-item active" data-interval="10000">
                      <div className="cards-wrapper row">
                        {this.state.detailedResults.slice(0,1).map(record=>{
                          var assetImageIndicator
                          try{
                            require('../public/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png')
                            assetImageIndicator = true
                          }
                          catch(e){
                            assetImageIndicator = false
                          }
                          return(
                            <div key={record.guid} className="mx-1 col card p-3 featured-data-record rounded border-0 shadow-sm" id={record.guid} onClick={this.handleClick}>
                              {assetImageIndicator===true?<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png'} alt="screenshot"></img>:<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']+'.png'} alt="screenshot"></img>}
                              <h6 className="w-100 font-weight-bold text-secondary card-title mb-0 p-1 search-results" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']}
                              </h6>
                              <h6 className="font-weight-bold text-secondary mt-1 small p-1 search-results entity-org" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] + " - " +record['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']}
                              </h6>
                              <h6 className="small text-secondary card-description mt-1 p-1" id={record.guid} onClick={this.handleClick} >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']===""?"There's no description available":record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']}
                              </h6>
                              <div className="w-100 text-center text-secondary px-1 form-inline card-features search-results">
                                  <i className="fas fa-circle fa-xs pt-3" style={{color: colorMap[record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0" >{record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"?"far fa-eye fa-xs pt-3":"far fa-eye-slash fa-xs pt-3"} style={{color:colorMap2[record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">PII: {record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="HTML"?"far fa-file-code pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="EXCEL"?"fas fa-table pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="SAP"?"fas fa-database pt-3":"fas fa-question pt-3"} style={{color:colorMap3[record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']]}}/>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">{record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']}</p>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    <div className="carousel-item" data-interval="10000">
                      <div className="cards-wrapper row">
                        {this.state.detailedResults.slice(1,2).map(record=>{
                          var assetImageIndicator
                          try{
                            require('../public/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png')
                            assetImageIndicator = true
                          }
                          catch(e){
                            assetImageIndicator = false
                          }
                          return(
                            <div key={record.guid} className="mx-1 col card p-3 featured-data-record rounded border-0 shadow-sm" id={record.guid} onClick={this.handleClick}>
                              {assetImageIndicator===true?<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png'} alt="screenshot"></img>:<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']+'.png'} alt="screenshot"></img>}
                              <h6 className="w-100 font-weight-bold text-secondary card-title mb-0 p-1 search-results" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']}
                              </h6>
                              <h6 className="font-weight-bold text-secondary mt-1 small p-1 search-results entity-org" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] + " - " +record['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']}
                              </h6>
                              <h6 className="small text-secondary card-description mt-1 p-1" id={record.guid} onClick={this.handleClick} >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']===""?"There's no description available":record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']}
                              </h6>
                              <div className="w-100 text-center text-secondary px-1 form-inline card-features search-results">
                                  <i className="fas fa-circle fa-xs pt-3" style={{color: colorMap[record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0" >{record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"?"far fa-eye fa-xs pt-3":"far fa-eye-slash fa-xs pt-3"} style={{color:colorMap2[record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">PII: {record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="HTML"?"far fa-file-code pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="EXCEL"?"fas fa-table pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="SAP"?"fas fa-database pt-3":"fas fa-question pt-3"} style={{color:colorMap3[record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']]}}/>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">{record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']}</p>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    <div className="carousel-item" data-interval="10000">
                      <div className="cards-wrapper row">
                        {this.state.detailedResults.slice(2,3).map(record=>{
                          var assetImageIndicator
                          try{
                            require('../public/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png')
                            assetImageIndicator = true
                          }
                          catch(e){
                            assetImageIndicator = false
                          }
                          return(
                            <div key={record.guid} className="mx-1 col card p-3 featured-data-record rounded border-0 shadow-sm" id={record.guid} onClick={this.handleClick}>
                              {assetImageIndicator===true?<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png'} alt="screenshot"></img>:<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']+'.png'} alt="screenshot"></img>}
                              <h6 className="w-100 font-weight-bold text-secondary card-title mb-0 p-1 search-results" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']}
                              </h6>
                              <h6 className="font-weight-bold text-secondary mt-1 small p-1 search-results entity-org" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] + " - " +record['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']}
                              </h6>
                              <h6 className="small text-secondary card-description mt-1 p-1" id={record.guid} onClick={this.handleClick} >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']===""?"There's no description available":record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']}
                              </h6>
                              <div className="w-100 text-center text-secondary px-1 form-inline card-features search-results">
                                  <i className="fas fa-circle fa-xs pt-3" style={{color: colorMap[record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0" >{record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"?"far fa-eye fa-xs pt-3":"far fa-eye-slash fa-xs pt-3"} style={{color:colorMap2[record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">PII: {record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="HTML"?"far fa-file-code pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="EXCEL"?"fas fa-table pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="SAP"?"fas fa-database pt-3":"fas fa-question pt-3"} style={{color:colorMap3[record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']]}}/>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">{record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']}</p>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                    <div className="carousel-item" data-interval="10000">
                      <div className="cards-wrapper row">
                        {this.state.detailedResults.slice(3,4).map(record=>{
                          var assetImageIndicator
                          try{
                            require('../public/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png')
                            assetImageIndicator = true
                          }
                          catch(e){
                            assetImageIndicator = false
                          }
                          return(
                            <div key={record.guid} className="mx-1 col card p-3 featured-data-record rounded border-0 shadow-sm" id={record.guid} onClick={this.handleClick}>
                              {assetImageIndicator===true?<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']+'.png'} alt="screenshot"></img>:<img className="searchPageImg" src={process.env.PUBLIC_URL+'/searchPageImages/'+record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID']+'.png'} alt="screenshot"></img>}
                              <h6 className="w-100 font-weight-bold text-secondary card-title mb-0 p-1 search-results" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Name']}
                              </h6>
                              <h6 className="font-weight-bold text-secondary mt-1 small p-1 search-results entity-org" >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Entity_ID'] + " - " +record['businessAttributes']['Metadata Applicable For Data Catalog']['Organization']}
                              </h6>
                              <h6 className="small text-secondary card-description mt-1 p-1" id={record.guid} onClick={this.handleClick} >
                                {record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']===""?"There's no description available":record['businessAttributes']['Metadata Applicable For Data Catalog']['Description']}
                              </h6>
                              <div className="w-100 text-center text-secondary px-1 form-inline card-features search-results">
                                  <i className="fas fa-circle fa-xs pt-3" style={{color: colorMap[record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0" >{record['businessAttributes']['Metadata Applicable For Data Catalog']['Sensitivity_Level']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']==="YES"?"far fa-eye fa-xs pt-3":"far fa-eye-slash fa-xs pt-3"} style={{color:colorMap2[record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']]}}></i>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">PII: {record['businessAttributes']['Metadata Applicable For Data Catalog']['PII']}</p>
                                  <span className="px-1 pt-3" >&#124;</span>
                                  <i className={record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="HTML"?"far fa-file-code pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="EXCEL"?"fas fa-table pt-3":record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']==="SAP"?"fas fa-database pt-3":"fas fa-question pt-3"} style={{color:colorMap3[record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']]}}/>
                                  <p className="pt-3 pl-1 font-weight-bold small mb-0">{record['businessAttributes']['Metadata Applicable For Data Catalog']['Database_Management_System']}</p>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                  <a className="carousel-control-prev" href="#carouselFade2" role="button" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="sr-only">Previous</span>
                  </a>
                  <a className="carousel-control-next" href="#carouselFade2" role="button" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="sr-only">Next</span>
                  </a>
                </div>



                
              </div>
            
              {/* <div className="w-100" id="select-by-entity">
                <h3 className="text-center text-secondary text-uppercase my-5 pb-3">
                  browse by entity and organization
                </h3>
                <ul className="nav nav-pills row my-4 p-1 border">
                  <li className="nav-item col">
                    <a className="nav-link active content-tab small font-weight-bold text-center p-3" data-toggle="pill" href="#un">United Nations</a>
                  </li>
                  <li className="nav-item col">
                    <a className="nav-link content-tab small font-weight-bold text-center p-3" data-toggle="pill" href="#rc">Regional Commission</a>
                  </li>
                  <li className="nav-item col">
                    <a className="nav-link content-tab small font-weight-bold text-center p-3" data-toggle="pill" href="#fm">Field Mission</a>
                  </li>
                  <li className="nav-item col">
                    <a className="nav-link content-tab small font-weight-bold text-center p-3" data-toggle="pill" href="#oafh">Office Away from Headquarters</a>
                  </li>
                  <li className="nav-item col">
                    <a className="nav-link content-tab small font-weight-bold text-center p-3" data-toggle="pill" href="#other">Other</a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div id="un" className="p-3 tab-pane fade show row entities-tab active">
                    {UNHQ_entities.map(item=>{
                      return(
                        <h6 className="float-left col-2 my-2 text-center entities-tab-item">
                          <a className="font-weight-bold text-secondary" value={item} onClick={this.handleSelectEntity}>{item}</a> 
                        </h6>
                      )
                    })}
                  </div>
                  <div id="rc" className="tab-pane fade row entities-tab">
                    {RC_entities.map(item=>{
                      return(
                        <h6 className="float-left col-2 my-2 text-center entities-tab-item">
                          <a className="font-weight-bold text-secondary" value={item} onClick={this.handleSelectEntity}>{item}</a> 
                        </h6>
                      )
                    })}
                  </div>
                  <div id="fm" className="tab-pane fade row entities-tab">
                    {FM_entities.map(item=>{
                      return(
                        <h6 className="float-left col-2 my-2 text-center entities-tab-item">
                          <a className="font-weight-bold text-secondary" value={item} onClick={this.handleSelectEntity}>{item}</a> 
                        </h6>
                      )
                    })}
                  </div>
                  <div id="oafh" className="tab-pane fade row entities-tab">
                    {OAFH_entities.map(item=>{
                      return(
                        <h6 className="float-left col-2 my-2 text-center entities-tab-item">
                          <a className="font-weight-bold text-secondary" value={item} onClick={this.handleSelectEntity}>{item}</a> 
                        </h6>
                      )
                    })}
                  </div>
                  <div id="other" className="tab-pane fade row entities-tab">
                    {OTHER_entities.map(item=>{
                      return(
                        <h6 className="float-left col-2 my-2 text-center entities-tab-item">
                          <a className="font-weight-bold text-secondary" value={item} onClick={this.handleSelectEntity}>{item}</a> 
                        </h6>
                      )
                    })}
                  </div>
                </div>
              </div> */}
            
              {/* <div className="w-100 mb-5 pb-5" id="select-by-sensitivity" >
                <h3 className="text-center text-secondary text-uppercase my-5 pb-3">
                browse by sensitivity level
                </h3>
                <ul className="nav nav-pills row my-5 p-1 border">
                  <li className="nav-item col">
                    <a className="nav-link active content-tab small font-weight-bold text-center p-3" 
                        data-toggle="pill" href="#" onClick={this.handleSelectSensitivityLevel}>PUBLIC</a>
                  </li>
                  <li className="nav-item col">
                    <a className="nav-link content-tab small font-weight-bold text-center p-3" 
                        data-toggle="pill" href="#" onClick={this.handleSelectSensitivityLevel}>NOT CLASSIFIED</a>
                  </li>
                  <li className="nav-item col">
                    <a className="nav-link content-tab small font-weight-bold text-center p-3" 
                        data-toggle="pill" href="#" onClick={this.handleSelectSensitivityLevel}>CONFIDENTIAL</a>
                  </li>
                  <li className="nav-item col">
                    <a className="nav-link content-tab small font-weight-bold text-center p-3" 
                        data-toggle="pill" href="#" onClick={this.handleSelectSensitivityLevel}>STRICTLY CONFIDENTIAL</a>
                  </li>
                </ul>
              </div> */}
            </div>
            <Footer />
          </React.Fragment>
           )
    }
   }
}

export default Search